<template>
  <div class="mini-tables-wrapper">
    <MiniDepStatTableReg
      :stats="convertObjToArray(depositsStats[filterOption]['register_time'])"
      :max-mini-tables-height="maxMiniTablesHeight"
    />
    <MiniDepStatTableDepTime
      :stats="convertObjToArray(depositsStats[filterOption]['deposit_time'])"
      :max-mini-tables-height="maxMiniTablesHeight"
    />
    <MiniDepStatTableDepAmounts
      :stats="convertObjToArray(depositsStats[filterOption]['amounts'])"
      :max-mini-tables-height="maxMiniTablesHeight"
    />
    <MiniDepStatTableDepTiers
      :stats="convertObjToArray(depositsStats[filterOption]['country_tier'])"
      :max-mini-tables-height="maxMiniTablesHeight"
    />
    <MiniDepStatTableDepCountries
      :stats="
        convertObjToArrayWithDictionaries(
          depositsStats[filterOption]['countries'],
          'countries'
        )
      "
      :max-mini-tables-height="maxMiniTablesHeight"
    />
    <MiniDepStatTableDepBrokers
      :stats="
        convertObjToArrayWithBrokers(
          depositsStats[filterOption]['brokers'],
          totalOrder['campaign_id'],
          'brokers'
        )
      "
      :max-mini-tables-height="maxMiniTablesHeight"
    />
    <MiniDepStatTableDepAgents
      :stats="
        convertObjToArrayWithAgents(
          depositsStats[filterOption]['agents'],
          totalOrder['user_id'],
          'brokers'
        )
      "
      :max-mini-tables-height="maxMiniTablesHeight"
    />

  </div>
</template>

<script>
import MiniDepStatTableReg from "./MiniStatsTables/MiniDepStatTableReg.component";
import MiniDepStatTableDepTime from "./MiniStatsTables/MiniDepStatTableDepTime.component";
import MiniDepStatTableDepAmounts from "./MiniStatsTables/MiniDepStatTableDepAmounts.component";
import MiniDepStatTableDepTiers from "./MiniStatsTables/MiniDepStatTableDepTiers.component";
import MiniDepStatTableDepCountries from "./MiniStatsTables/MiniDepStatTableDepCountries.component";
import { mapState } from "vuex";
import MiniDepStatTableDepBrokers from "./MiniStatsTables/MiniDepStatTableDepBrokers.component";
import MiniDepStatTableDepAgents from "./MiniStatsTables/MiniDepStatTableDepAgents.component";
export default {
  name: "DepositsStatsTables",
  computed: {
    ...mapState("clients", ["dictionaries", "salesPersonList"]),
    ...mapState("user", ["auth"]),

  },
  components: {
    MiniDepStatTableDepAgents,
    MiniDepStatTableDepBrokers,
    MiniDepStatTableDepCountries,
    MiniDepStatTableDepTiers,
    MiniDepStatTableDepAmounts,
    MiniDepStatTableDepTime,
    MiniDepStatTableReg
  },
  props: {
    depositsStats: {
      type: Array
    },
    filterOption: {
      type: String
     },
    totalOrder:{
      type: Object
},
  },

  methods: {
    convertObjToArray(obj) {
      if (obj) {
        let keys = Object.keys(obj);
        let tempArr = [];
        keys.forEach(key => {
          tempArr.push({
            title: key,
            value: obj[key]
          });
        });

        return tempArr.sort((a, b) => {
          return b.value - a.value;
        });
      }
    },
    convertObjToArrayWithDictionaries(obj, dictionary) {
      if (obj) {
        let keys = Object.keys(obj);
        let tempArr = [];
        keys.forEach(key => {
          tempArr.push({
            title: this.dictionaries.general[dictionary].find(
              place => place.id == key
            ).name,
            value: obj[key]
          });
        });
        // return tempArr;
        return tempArr.sort((a, b) => {
          return b.value - a.value;
        });
      }
    },
    convertObjToArrayWithBrokers(obj,obj2, dictionary) {
      if (obj) {

        let keys = Object.keys(obj);
        let tempArr = [];
        keys.forEach(key => {

          tempArr.push({
            title: this.dictionaries.general[dictionary].find(
              broker => broker.id == key
            ).name,
            value: obj[key],
            amount: obj2[key]
          });
        });
        return tempArr.sort((a, b) => {
          return b.value - a.value;
        });
      }
    },
    convertObjToArrayWithAgents(obj,obj2, dictionary) {

      if (obj) {
        let keys = Object.keys(obj);
        let tempArr = [];
        keys.forEach(key => {
          let user = this.salesPersonList.find(user => user.id === keys[0]);
          tempArr.push({
            title: this.salesPersonList.find(user => user.id == key).full_name,
            value: obj[key],
            amount: obj2[key]
          });
        });
        return tempArr.sort((a, b) => {
          return b.value - a.value;
        });
      }
    }
  },
  data() {
    return {
      maxMiniTablesHeight: "210px"
    };
  }
};
</script>

<style scoped>
.mini-tables-wrapper {
  display: flex;
  height: 100%;
}
</style>
